import { ConverterFactory } from "opencc-js/core";
import phraseDictionary from "./opencc-python-0.1.7/TSPhrases.txt?raw";
import characterDictionary from "./opencc-python-0.1.7/TSCharacters.txt?raw";
import canonicalExceptions from "./opencc-python-0.1.7/CanonicalExceptions.txt?raw";

export const DECODE_NORMALIZER = {
  library: "opencc-js",
  version: "1.4.2",
  configuration: "cn-1 exceptions, then ConverterFactory([TSPhrases.txt, TSCharacters.txt])",
  pipeline: "NFC; retain U+3400-U+9FFF; convert; retain U+3400-U+9FFF",
  dictionarySource: "opencc-python-reimplemented@0.1.7:t2s",
  phraseDictionarySha256: "b2ef895dd4953b4bb77fc8ef8d26a2a9ca6d43a760ed9a1d767672cfafa6324f",
  characterDictionarySha256: "6b5a0a799bea2bb22c001f635eaa3fc2904310f0c08addbff275477a80ecf09a",
  canonicalExceptionsSha256: "c2af96c7f7b7f18130d4e92df203299cde2a5b0ecc5961c443142e4b6059e847",
  integrity: "sha512-EdcspgdROiCCZDM+jZR6Pa670xW+EW2QhctPBQ8gRjg6lrx4IHEl+2s+kt5izk/TkxVRgdWuFgaGkaEdIUfdaw==",
} as const;

function parseDictionary(source: string): ReadonlyArray<readonly [string, string]> {
  return source.trim().split(/\r?\n/u).map((line) => {
    const separator = line.indexOf("\t");
    if (separator < 1) throw new Error("Malformed vendored OpenCC dictionary entry.");
    const replacement = line.slice(separator + 1).split(" ", 1)[0];
    if (!replacement) throw new Error("Malformed vendored OpenCC dictionary replacement.");
    return [line.slice(0, separator), replacement] as const;
  });
}

const toSimplified = ConverterFactory([parseDictionary(phraseDictionary), parseDictionary(characterDictionary)]);
const canonicalFixedPoints = new Set(canonicalExceptions.trim().split(/\r?\n/u));
const CJK = /[\u3400-\u9fff]/gu;

export function normalizeCorpusLine(value: string): string {
  const cjkOnly = (value.normalize("NFC").match(CJK) ?? []).join("");
  if (canonicalFixedPoints.has(cjkOnly)) return cjkOnly;
  return (toSimplified(cjkOnly).match(CJK) ?? []).join("");
}
